import React from "react";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";

export default function RecruiterClientItem(props) {
  let clusterURL;
  const { company } = props;

  const companyName = company.companyName.substring(0, company.companyName.indexOf("(") - 1);
  const formattedCompanyName = companyName.replaceAll(" ", "-").toLowerCase();

  const { recruiterUsername } = useParams();

  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    clusterURL = `/recruiters/${recruiterUsername}/clients/@${formattedCompanyName}`;
  } else {
    clusterURL = `/clients/@${formattedCompanyName}`;
  }

  return (
    <tr className="cursor-pointer bg-white border-b hover:bg-gray-50 text-gray-700">
      <td className="flex items-center px-6 py-4">
        <img className="w-10 h-10 rounded-full" src={company.profileImageURL} alt={company.roleName} />
        <div className="pl-3">
          <div className="text-base font-semibold">
            <Link to={clusterURL}>{company.companyName}</Link>
          </div>
          <div className="font-normal">{company.location}</div>
        </div>
      </td>
      <td className="px-6 py-4">{Math.floor(Math.random() * 10210)}</td>
      <td className="px-6 py-4">{`@${formattedCompanyName}`}</td>
      <td className="px-6 py-4">{Math.floor(Math.random() * 10210)}</td>
      <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
    </tr>
  );
}
